export const BASIC_ADDRESS_STEP = "basic-address"
export const BASIC_ADDRESS_DESCRIPTION = "Motorcycle Technical Specifications"

export const ADDRESS_LINE_1 = "address_line_1"
export const ADDRESS_LINE_2 = "address_line_2"
export const ADDRESS_CITY = "address_city"
export const ADDRESS_REGION = "address_region"
export const ADDRESS_COUNTRY = "address_country"
export const TIMEZONE = "timezone"
export const ADDRESS_POSTAL_CODE = "address_postal_code"